// import React from "react";
// import ReactDOM from "react-dom/client";
// import App from "./App";
// import reportWebVitals from "./reportWebVitals";
// import LoadingSpinner from "./vyn/components/loader";

// import "antd/dist/reset.css";
// import { StoreProvider } from "./store";

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   <StoreProvider>
//     <LoadingSpinner />
//     <App />
//   </StoreProvider>
// );

// // If you want to start measuring performance in your app, pass a function
// // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();


import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import LoadingSpinner from "./vyn/components/loader";
import "antd/dist/reset.css";
import { StoreProvider } from "./store";
import { ErrorBoundary } from "react-error-boundary";
function ErrorFallback() {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h2>⚠️ Something went wrong</h2>
      <p>Please try again later.</p>
    </div>
  );
}
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <StoreProvider>
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <LoadingSpinner />
      <App />
    </ErrorBoundary>
  </StoreProvider>
);

reportWebVitals();
